// extracted by mini-css-extract-plugin
module.exports = {"bottomSpace":"TemplateSelector_bottomSpace__39wwT","error":"TemplateSelector_error__3HjUr"};